import React, { useState, useEffect, useContext } from "react";
import PopoverInput from "./inner/popoverInput.jsx";
import { DataSourceContext, IsMobileContext } from "../context/contexts.jsx";

const icon = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 20.0005C18 21.1051 15.3137 22.0005 12 22.0005C8.68629 22.0005 6 21.1051 6 20.0005M15 9.50049C15 11.1574 13.6569 12.5005 12 12.5005C10.3431 12.5005 9 11.1574 9 9.50049C9 7.84364 10.3431 6.50049 12 6.50049C13.6569 6.50049 15 7.84364 15 9.50049ZM12 2.00049C16.0588 2.00049 19.5 5.42852 19.5 9.58739C19.5 13.8125 16.0028 16.7775 12.7725 18.7937C12.5371 18.9292 12.2709 19.0005 12 19.0005C11.7291 19.0005 11.4629 18.9292 11.2275 18.7937C8.00325 16.7578 4.5 13.8271 4.5 9.58739C4.5 5.42852 7.9412 2.00049 12 2.00049Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"></path>
</svg>;
const DetailedSelectItem = ({ destination, onSelect }) => {
    return (
        <div className={"text-content_2 hover:bg-content_5 rounded-[8px] mr-2 h-20  form-checkbox-text-left  "} onClick={() => onSelect(destination)}>
            <div className="w-25 p-1">
                {destination.type == "Hotel" &&
                    <img className="rounded-[8px]" src={destination.image + "?width=100"} />
                }
            </div>
            <div className="flex flex-col h-1/1 justify-around">
                <div className="text-tiny text-content_3">{destination.ancestors?.join(" > ")}</div>
                <div className="text-lg">{destination.name}</div>
            </div>
        </div>);
}

const SimpleSelectItem = ({ destination, onSelect, type }) => {
    return (
        <div className={"text-content_2 hover:bg-content_5 rounded-[8px] mr-2  form-checkbox-text-left " + (type == "region" ? " pl-8" : "")} onClick={() => onSelect(destination)}>
            {destination.name}
        </div>)
}

const DestinationPicker = ({ departureAirports, selectedDestination,accomIsLocked, onUpdate }) => {
    const [flatDestinations, setFlatDestinations] = useState(null);
    const [filteredDestinations, setFilteredDestinations] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [filterText, setFilterText] = useState("");
    const dataSource = useContext(DataSourceContext);
    const isMobile = useContext(IsMobileContext);
    useEffect(() => {
        async function fetchData() {
            setFlatDestinations(null);
            if (departureAirports.length > 0) {
                var destinations = await dataSource.getDestinations(departureAirports);
                setFlatDestinations(destinations);
            }
        }
        fetchData();
    }, [departureAirports]);

    useEffect(() => {
        async function fetchData() {
            setFilteredDestinations(null);
            var destinations = await dataSource.getDestinationsWithTextSearch(departureAirports, filterText);
            setFilteredDestinations(destinations);
        }
        if (filterText && filterText != "") {
            fetchData();
        } else {
            setFilteredDestinations(null);
        }
    }, [filterText]);

    const onSelect = (selected) => {
        setFilterText("");
        setFilteredDestinations(null);
        setIsOpen(false);
        onUpdate({ name: selected.name, code: selected.code });
    }

    let inputText = "Destination or Hotel";
    if (selectedDestination) {
        inputText = selectedDestination.name;
    }

    let entries = [];
    if (filteredDestinations) {
        for (let index = 0; index < filteredDestinations.destinations.length; index++) {
            const country = filteredDestinations.destinations[index];
            entries.push(<DetailedSelectItem destination={country} key={index} onSelect={onSelect} />);
        }
    } else {
        if (flatDestinations) {
            for (let index = 0; index < flatDestinations.countries.length; index++) {
                const country = flatDestinations.countries[index];
                entries.push(<SimpleSelectItem destination={country} key={index} onSelect={onSelect} type="country" />);
                for (let rIndex = 0; rIndex < country.regions.length; rIndex++) {
                    const element = country.regions[rIndex];
                    entries.push(<SimpleSelectItem destination={element} key={index + "_" + rIndex} onSelect={onSelect} type="region" />)
                }
            }
        }
    }
    let footer = null;
    if (isMobile) {
        footer = <div className="relative">
            <input type="text" value={filterText} onChange={(e) => setFilterText(e.target.value)} className="form-input form-input--with-icon" placeholder={"Search"} />
            <span className="absolute left-3 top-[20px] -translate-y-1/2 pointer-events-none text-content_2">
                {icon}
            </span>
        </div>;
    }
    return <PopoverInput footer={footer} disabled={departureAirports.length == 0 || accomIsLocked} icon={icon} inputText={inputText} isLoading={flatDestinations == null} onTextUpdate={setFilterText} filterText={filterText} isOpen={isOpen} setIsOpen={setIsOpen}>
        <div className="">
            {entries}
        </div>
    </PopoverInput>
}
export default DestinationPicker;
